import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  default(event) {
    event.preventDefault()
    this.print({ price: true, creator: false })
  }

  withCreator(event) {
    event.preventDefault()
    this.print({ price: true, creator: true })
  }

  withoutPrice(event) {
    event.preventDefault()
    this.print({ price: false, creator: false })
  }

  withoutPriceWithCreator(event) {
    event.preventDefault()
    this.print({ price: false, creator: true })
  }

  print({ price, creator }) {
    this.element.querySelectorAll(".no_print1").forEach(el => el.classList.toggle("no_print", !price))
    this.element.querySelectorAll(".no_print2").forEach(el => el.classList.toggle("no_print", !creator))
    window.print()
  }
}
